var alertTriggerControls = {
	limits: "Limits",
	upperLimit: "Upper Limit",
	upperLimitPlaceholder: "Upper limit price",
	lowerLimit: "Lower Limit",
	lowerLimitPlaceholder: "Lower limit price",
	deleteBtn: "Delete",
	cancelBtn: "Cancel",
	saveBtn: "Ok",
	validationErrors: {
		upperLimit: {
			invalidInput: "Invalid input. Valid pattern: 123.456",
			priceMismatch: "The upper limit must be higher than the current price"
		},
		lowerLimit: {
			invalidInput: "Invalid input. Valid pattern: 123.456",
			priceMismatch: "The lower limit must be lower than the current price"
		}
	}
};
var en = {
	alertTriggerControls: alertTriggerControls
};

export { alertTriggerControls, en as default };
